/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import Moment from 'react-moment';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  asset: Object,
  form: TypeForm,
};

@translate()
@observer
export default class RequestOwnershipMultiForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, asset, form }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock gutters={true} heading={form.$('requestReason').label}>
            <ElectroSelectWithOther
              field={form.$('requestReason.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.request')} />
      </React.Fragment>
    );
  }
}
